import React, { FunctionComponent, SVGProps } from 'react';
import styled from 'styled-components';

interface BotIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  isGrey?: boolean;
}

const BotIcon: FunctionComponent<BotIconProps> = ({
  className,
  isGrey,
  ...props
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      {...props}
    >
      <circle
        className={`circle ${isGrey ? 'grey' : ''}`}
        cx="16"
        cy="16"
        r="16"
      />
      <path
        className={`path ${isGrey ? 'grey' : ''}`}
        d="M21.95,17.06h-.35v-.71c0-.56-.22-1.1-.62-1.5-.39-.4-.93-.62-1.49-.62h-2.8v-1.61c.36-.21,.61-.57,.68-.98,.07-.41-.04-.83-.31-1.15-.27-.32-.66-.5-1.07-.5s-.81,.18-1.07,.5c-.27,.32-.38,.74-.31,1.15s.32,.77,.68,.98v1.61h-2.8c-.56,0-1.09,.22-1.49,.62-.39,.4-.62,.94-.62,1.5v.71h-.35c-.38,0-.72,.2-.91,.53-.19,.33-.19,.73,0,1.06,.19,.33,.53,.53,.91,.53h.35v.71c0,.56,.22,1.1,.62,1.5,.39,.4,.93,.62,1.49,.62h7c.56,0,1.09-.22,1.49-.62,.39-.4,.62-.94,.62-1.5v-.71h.35c.37,0,.72-.2,.91-.53,.19-.33,.19-.73,0-1.06-.19-.33-.53-.53-.91-.53Zm-7.35,1.06c0,.28-.11,.55-.31,.75-.2,.2-.46,.31-.74,.31s-.55-.11-.74-.31-.31-.47-.31-.75,.11-.55,.31-.75c.2-.2,.46-.31,.74-.31s.55,.11,.74,.31c.2,.2,.31,.47,.31,.75Zm4.9,0c0,.28-.11,.55-.31,.75-.2,.2-.46,.31-.74,.31s-.55-.11-.74-.31-.31-.47-.31-.75,.11-.55,.31-.75c.2-.2,.46-.31,.74-.31s.55,.11,.74,.31c.2,.2,.31,.47,.31,.75Z"
      />
    </svg>
  );
};

export default styled(BotIcon)`
  width: 32px;
  height: 32px;

  .circle {
    isolation: isolation;
    opacity: 0.1;
    fill: ${({ theme }) => theme.colors.accent};

    &.grey {
      opacity: 1;
      fill: ${({ theme }) => theme.colors.secondary};
    }
  }

  .path {
    fill: ${({ theme }) => theme.colors.accent};

    &.grey {
      fill: ${({ theme }) => theme.colors.tertiary};
    }
  }
`;
